export default __webpack_public_path__ + "static/media/FontsFree-Net-Telegraf-Regular.755af8b4.ttf";